export const emailValidation = value => {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!value) {
    return { emailAddress: '*Required' };
  } else if (!emailRegex.test(value)) {
    return { emailAddress: '*Invalid Email Address' };
  }
  return {};
};

export const emailValidationOrderConf = value => {
  const actualValidation = emailValidation(value);
  if (actualValidation && actualValidation.emailAddress) {
    return { emailAddress: '*Please enter a valid email address' };
  }
  return actualValidation;
};
export const phoneValidation = value => {
  const phoneNumberRegex = /^[2-9]\d{2}-?\d{3}-?\d{4}$/;
  if (!value) {
    return { phoneNumber: '*Required' };
  } else if (!phoneNumberRegex.test(value)) {
    return { phoneNumber: '*Invalid Phone Number' };
  }
  return {};
};

export const street1Validation = value => {
  const streetAddressRegex = /^(?=.*\S).+$/;
  if (!value) {
    return { street1: '*Required' };
  } else if (!streetAddressRegex.test(value)) {
    return { street1: '*Must Enter Valid Street Address' };
  }
  return {};
};

export const cityValidation = value => {
  const cityRegex = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
  if (!value) {
    return { city: '*Required' };
  } else if (!cityRegex.test(value)) {
    return { city: '*Invalid City' };
  }
  return {};
};

export const stateValidation = value => {
  if (value === '---') {
    return { state: '*Required' };
  }
  return {};
};

export const postalCodeValidation = value => {
  const postalCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
  if (!value) {
    return { postalCode: '*Required' };
  } else if (!postalCodeRegex.test(value)) {
    return { postalCode: '*Invalid Postal Code' };
  }
  return {};
};



// WEBPACK FOOTER //
// ./src/components/Forms/Validations/addressValidations.js